import I18n from 'i18n-js';
import React from 'react';
import Tooltip from '../Tooltip/Tooltip.js';

export default class BarChart extends React.Component {
	constructor(props) {
		super(props);

		const data = this.props.data || {data: [], yAxis: []}

		this.state = {
			data: data,
			loading: data && data.length ? false : true
		};

		this.loadData = this.loadData.bind(this);
	}

	componentDidMount() {
		if (!this.state.data || this.state.data.data.length === 0) {
			this.loadData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.endpoint !== this.props.endpoint) {
			this.loadData();
		}
	}

	render() {
		// console.log(this.props)
		let bars = null;
		let labels = null;
		let val = 0;
    let highestValue = this.state.data.yAxis[4]
    let sum = 0;

		if (this.state.data && this.state.data.data && this.state.data.data.length) {
			val = 100 / this.state.data.data.length;
      sum = this.state.data.data.reduce((accumulator, item) => accumulator + item.value, 0);
			bars = this.state.data.data.map((b, idx) => (
				<Tooltip text={`${b.name}: ${b.value}`} key={b.name}>
					<div
						key={b.name}
						className="bar"
						style={{
							backgroundColor: b.color,
							height: `${(b.value / highestValue) * 100}%`,
							width: `${val - 5}%`,
							left: `${idx * val}%`
						}}
					/>
				</Tooltip>
			));
			labels = this.state.data.data.map((b, idx) => (
				<div
					key={b.name}
					className="bar-name"
					style={{
						width: `${val - 5}%`,
						left: `${idx * val}%`
					}}
				>
					{b.name}
				</div>
			));
		}

		return (
			<div className="BarChart">
				{this.state.loading ? (
					<div className="loadingOverlay">
						<div className="spinner" />
					</div>
				) : null}
        {
          sum > 0
          ?
          (
            <div className="BarChart-container">
            <div className="grid-container">
              <div className="y-axis-container">
                <span className="percent-label percent-label-100">{this.state.data.yAxis[4]}</span>
                <span className="percent-label percent-label-75">{this.state.data.yAxis[3]}</span>
                <span className="percent-label percent-label-50">{this.state.data.yAxis[2]}</span>
                <span className="percent-label percent-label-25">{this.state.data.yAxis[1]}</span>
                <span className="percent-label percent-label-0">{this.state.data.yAxis[0]}</span>
              </div>
              <div className="body-container">
                <div className="percent-section" />
                <div className="percent-section" />
                <div className="percent-section" />
                <div className="percent-section percent-section-bottom" />
              </div>
            </div>
            <div className="bars-container">
              {bars}
              <div className="bar-label-container">{labels}</div>
            </div>
          </div>
          )
          :
          <div className="no-data"><div className="text">{I18n.t('admin.no_data_available')}</div></div>
        }
      </div>
		);
	}

	loadData() {
		this.setState({ loading: true });
		$.ajax({
			type: 'GET',
			url: this.props.endpoint
		}).done((data) => {
			//console.log('BarChart loadData done', data);
			this.setState({ data: data, loading: false });
		});
	}
}
